import type { Page, PageBadge, Platform } from '@regia/shared';
import { PlatformIcon } from '../../lib/platforms';
import { FolderBadge, type FolderItem, FolderStack } from '../../ui';

function uniquePlatforms(page: Page): Platform[] {
  return [...new Set(page.channels.map((c) => c.platform))];
}

export function toFolderItems(
  pages: Page[],
  badges: Record<string, PageBadge[]> = {},
): FolderItem[] {
  return pages.map((page) => {
    const platforms = uniquePlatforms(page);
    const pageBadges = badges[page.id] ?? [];
    return {
      id: page.id,
      name: page.name,
      color: page.color,
      href: `/schede/${page.slug}`,
      logoUrl: page.logoUrl,
      meta: (
        <>
          {platforms.length > 0 ? (
            <span className="mr-1 inline-flex items-center gap-1.5 opacity-90">
              {platforms.map((p) => (
                <PlatformIcon key={p} platform={p} size={18} />
              ))}
            </span>
          ) : null}
          {pageBadges.map((b) => (
            <FolderBadge
              key={b.label}
              tone={b.severity === 'alert' ? 'alert' : b.severity === 'warn' ? 'warn' : undefined}
            >
              {b.label}
            </FolderBadge>
          ))}
          {platforms.length === 0 && pageBadges.length === 0 ? (
            <span className="text-sm font-medium opacity-80">
              {page.kind === 'mio' ? 'Mia' : 'Cliente'}
            </span>
          ) : null}
        </>
      ),
    };
  });
}

export function PageFolders({
  pages,
  badges,
}: {
  pages: Page[];
  badges?: Record<string, PageBadge[]>;
}) {
  return <FolderStack items={toFolderItems(pages, badges)} />;
}
